"use strict";
exports.__esModule = true;
var ChangeLog = /** @class */ (function () {
    function ChangeLog(changeLogData) {
        this.changeLogData = changeLogData;
    }
    ChangeLog.prototype.changeString = function (changeLogItem) {
        var answer = "";
        if (changeLogItem.valueNew === changeLogItem.valueOld) {
            if (changeLogItem.commentPrev !== changeLogItem.commentCurrent) {
                answer = quote("Comment Changed");
            }
        }
        else {
            if (changeLogItem.inputType === "SCALAR") {
                answer = quote(changeLogItem.valueOld + "-->" + changeLogItem.valueNew);
            }
            else if (changeLogItem.inputType === "DISTRIBUTION") {
                answer = quote("(" + changeLogItem.valueOld.join() + ")-->(" + changeLogItem.valueNew.join() + ")");
            }
            else if (changeLogItem.inputType === "TABLE") {
                answer = quote("Table Changed");
            }
            else if (changeLogItem.inputType === "Category") {
                answer = quote((changeLogItem.valueOld || "(Not Selected)") + "-->"
                    + (changeLogItem.valueNew || "(Not Selected)"));
            }
            else {
                answer = quote("Data Changed");
            }
        }
        return answer;
    };
    ChangeLog.prototype.toCSV = function () {
        var answer = "";
        answer += 'Timestamp, Breadcrumb, Node, User, Type of Node, Input, Change\n';
        for (var i = 0; i < this.changeLogData.length; i++) {
            var changeLogItem = this.changeLogData[i];
            var type = changeLogItem.platform ? "Platform" : changeLogItem.leaf ? "Leaf" : changeLogItem.parent ? "Parent" : "Unknown";
            var line = [changeLogItem.timestamp, changeLogItem.nodeBreadcrumb, changeLogItem.nodeName, changeLogItem.user, type, changeLogItem.inputDisplay];
            var lineString = "";
            line.forEach(function (item) {
                lineString += quote(item) + ",";
            });
            lineString += this.changeString(changeLogItem);
            answer += lineString + "\n";
        }
        return answer;
    };
    return ChangeLog;
}());
function quote(s) {
    return '"' + s + '"';
}
exports["default"] = ChangeLog;
//# sourceMappingURL=change-log.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/logic/change-log.js